import styles from './SuccessSubmit.module.css'
import { CheckOutlined } from '@ant-design/icons'
import { SucessSVG } from '../../../svg/SvgComponents'

function SuccessSubmit({ urlCode, DataForm }) {
  console.log('urlCode', urlCode)

  return (
    <div className={styles.page}>
      <div className={styles.bloc}>
        <div className={styles.content_bloc}>
          <div className={styles.bloc1}>
            <div className={styles.content_valide}>
              <SucessSVG width={80} height={80} />
            </div>
            <div className={styles.content_bloc_title}>
              {DataForm.success_message ||
                'Votre saisie du formulaire a bien été effectuée !'}
            </div>
          </div>
          <div className={styles.bloc2}>
            {DataForm.show_answerAgain_button && (
              <div className={styles.content_bouton}>
                <a href={`/viewform/${urlCode}/`} rel="noopener noreferrer">
                  <div className={styles.bouton}>Saisir à nouveau</div>
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SuccessSubmit
